<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">
    <page-header
      title="License Code Usage"
      description="License code redemption and usage statistics."
    />

    <BaseReport
      data-endpoint="access-code-usage"
      metric-endpoint="access-code-usage-ratio">
      <template #metric-content="{ metricData, additionalMetricData }">
        <UsageSummaryMetricTiles
          :data="metricData"
          :adoption-total="additionalMetricData?.total"
          category-title="Voucher Code Usage Summary"
          category-icon="fa fa-ticket"
          completed-label="Used"
          pending-label="Unused"
          percentage-label="Usage Rate"
        />
      </template>

      <template #report-content="{ tableData, handleGroupChange, exportReport }">
        <UsageReportTable
          :report-data="tableData"
          @change-group="handleGroupChange"
          @export-report="exportReport"
        />
      </template>

    </BaseReport>
  </authenticated-layout>
</template>

<script setup lang="ts">
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import UsageSummaryMetricTiles from "@/pages/Insights/ReportsDetailPage/components/UsageSummaryMetricTiles.vue";
import UsageReportTable from "@/pages/Insights/ReportsDetailPage/components/UsageReportTable.vue";
import BaseReport from "@/pages/Insights/ReportsDetailPage/components/BaseReport.vue";
import { computed } from "vue";
import {useReportingStore} from "@/store/reporting";

const reportingState = useReportingStore();
reportingState.resetState();
reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "License Code Usage" }
]);

</script>
